<h2 mat-dialog-title>
  {{ title | translate }}
</h2>

<mat-dialog-content>
  <form [formGroup]="form" (submit)="submit()">
    <mat-form-field class="adf-full-width">
      <input
        id="adf-folder-name-input"
        placeholder="{{ 'APP.JOB-DOCUMENTS.DIALOGS.CREATE-PDF.TARGET-FOLDER' | translate }}"
        matInput
        required
        readonly="true"
        [formControl]="$any(form).controls['targetFolder']"
        [matTooltip]="targetFolderToolTip"
        matTooltipPosition="above"
      />

      <mat-hint *ngIf="form.controls['targetFolder'].dirty">
        <span *ngIf="form.controls['targetFolder']?.hasError('required')">
          {{ 'APP.JOB-DOCUMENTS.DIALOGS.CREATE-PDF.ERRORS.TARGET-FOLDER-REQUIRED' | translate }}
        </span>
      </mat-hint>

      <button
        name="open-category-folder-selector-dialog"
        mat-button
        matSuffix
        mat-icon-button
        title="{{ 'APP.JOB-DOCUMENTS.DIALOGS.CREATE-PDF.TARGET-FOLDER' | translate }}"
        (click)="openCategoryFolderSelectorDialog()"
      >
        <mat-icon>folder</mat-icon>
      </button>

    </mat-form-field>

    <mat-form-field class="adf-full-width">
          <mat-select
            id="jobdocuments-document-type-input"
            [formControl]="$any(form).controls['documentType']"
            placeholder="{{ 'APP.JOB-DOCUMENTS.DIALOGS.CREATE-PDF.DOCUMENT-TYPE' | translate }}"
            required
          >
            <mat-option></mat-option>
            <mat-option *ngFor="let item of documentTypes" [value]="item">
              {{ item }}
            </mat-option>
          </mat-select>

          <mat-error class="error-message" *ngIf="form.get('documentType')?.hasError('required') &&
          (form.get('name')?.dirty || form.get('documentType')?.touched)">
          {{ 'APP.JOB-DOCUMENTS.DIALOGS.CREATE-PDF.ERRORS.DOCUMENT-TYPE-REQUIRED' | translate }}
          </mat-error>

        </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="adf-dialog-buttons">
  <span class="adf-fill-remaining-space"></span>

  <button mat-button id="adf-folder-cancel-button" mat-dialog-close>
    {{ 'CORE.FOLDER_DIALOG.CANCEL_BUTTON.LABEL' | translate }}
  </button>

  <button
    class="adf-dialog-action-button"
    id="adf-folder-create-button"
    mat-button
    (click)="submit()"
    [disabled]="!form.valid"
  >
  {{ submitButtonLabel | translate }}

  </button>
</mat-dialog-actions>
